import { Component } from '@angular/core';

/**
 * Component for the home page.
 */
@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {

}
